import React, { useState, useEffect } from "react";
import SideBar from "../../Components/SideBar";
import TopBar from "../../Components/TopBar";
import { Container, MainContent } from "./styles";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleSideBarNavigation } from "../../Redux/actions/auth";
import ChatModal from "../../Components/Chat";

const DashboardLayout = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const screenWidth = window.innerWidth;
  const { topBarList, isChatOpen, isInstructor } = useSelector((state) => state.auth);
  const { allCourses } = useSelector((state) => state.home);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [toggleSideBar, setToggleSideBar] = useState(
    screenWidth > 600 ? true : false
  );
  const handleSelectGroup = (group) => {
    setSelectedGroup(group);
  };
  const handleMenu = (nav) => {
    dispatch(handleSideBarNavigation(nav));
    if (nav.title === "Website Home" || nav.title === "Learn About Dashboard") {
      window.location.replace(nav?.navigate);
    } else {
      navigate(`${nav?.navigate}`);
    }
  };
  const handleSideBar = () => setToggleSideBar(!toggleSideBar);
  const location = useLocation();

  useEffect(() => {
    let selectedTab = topBarList.filter((f) => f.isSelected)[0];
    if (
      location.pathname !== selectedTab?.navigate &&
      location.pathname !== "/chats" &&
      location.pathname !== "/editProfile"
    ) {
      let currentTab = topBarList.filter(
        (f) => f.navigate === location.pathname
      )[0];
      handleMenu(currentTab);
    } else if (location.pathname === "/chats") {
      let nav = { title: "Messages" };
      dispatch(handleSideBarNavigation(nav));
    } else if (location.pathname === "/editProfile") {
      let nav = { title: "Edit Profile" };
      dispatch(handleSideBarNavigation(nav));
    }
  }, [location.pathname]);

  return (
    <Container>
      <TopBar handleSideBar={handleSideBar} handleMenu={handleMenu} />
      <MainContent isChatOpen={isChatOpen.isOpen} isInstructor={isInstructor}>{children}</MainContent>
      <ChatModal
        toggleSideBar={toggleSideBar}
        handleSideBar={handleSideBar}
        navigate={navigate}
        groups={allCourses}
        myCourseLoading={false}
        onSelectGroup={handleSelectGroup}
        selectedGroup={selectedGroup}
        isChatOpen={isChatOpen}
      />
      {isChatOpen.isOpen &&
        <SideBar
          isChatOpen={isChatOpen}
          toggleSideBar={toggleSideBar}
          isInstructor={isInstructor}
        />
      }
    </Container>
  );
};

export default DashboardLayout;
